import React from "react";
import { bool, string, func } from "prop-types";

import "./checkbox.m.css";

const CheckBox = ({ isChecked, isHighlighting, text, value, type, onChange }) => (
  <label styleName="wrapper" className="checkbox">
    <span styleName={isHighlighting && isChecked ? "selected" : ""}>{text}</span>
    <input type="checkbox" value={value} checked={isChecked} onChange={onChange} />
    <span styleName={type} className={type}></span>
  </label>
);

CheckBox.defaultProps = {
  type: "type1",
  isHighlighting: false,
};

CheckBox.propTypes = {
  isChecked: bool,
  isHighlighting: bool,
  text: string,
  value: string,
  type: string,
  onChange: func,
};

export default CheckBox;
